(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["listicle-reasons"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-lr]');
    if (!root) return;

    /* Carry tracking params through to the PDP. The CTA hrefs are bare paths, so a
       visitor arriving on /pages/x?utm_source=... would otherwise land on the product
       page with nothing attached, and anything reading UTMs off the current URL
       (Redtrack, ClickFlare, most attribution apps) sees a direct visit.

       Shopify's own landing_site still records the original URL either way - this is
       for the tools that read the live query string rather than the session. */
    try {
      var incoming = new URLSearchParams(window.location.search);
      if (incoming.toString()) {
        var links = root.querySelectorAll('a[data-cta]');
        for (var i = 0; i < links.length; i++) {
          var a = links[i];
          var href = a.getAttribute('href');
          if (!href || /^(https?:)?\/\//i.test(href) || href.charAt(0) === '#') continue;
          var parts = href.split('#');
          var base = parts[0];
          var hash = parts[1] ? '#' + parts[1] : '';
          var q = base.indexOf('?');
          var path = q === -1 ? base : base.slice(0, q);
          var existing = new URLSearchParams(q === -1 ? '' : base.slice(q + 1));
          incoming.forEach(function (v, k) { if (!existing.has(k)) existing.set(k, v); });
          var qs = existing.toString();
          a.setAttribute('href', path + (qs ? '?' + qs : '') + hash);
        }
      }
    } catch (e) { /* never block the page */ }

    /* Sticky CTA. Appears when the third reason comes into view, matching where the
       reference brings it up, and hides again whenever an inline CTA is on screen so two
       identical buttons are never visible at once.

       Scroll position rather than IntersectionObserver: an observer only fires when
       isIntersecting CHANGES, so jumping past the trigger goes false -> false and the
       bar never appears. */
    var bar = root.querySelector('[data-lr-sticky]');
    var reasons = root.querySelectorAll('.el-lr__reason');
    var trigger = reasons[2] || reasons[reasons.length - 1] || root.querySelector('.el-lr__head');
    if (bar && trigger) {
      var ctas = root.querySelectorAll('.el-lr__cta');
      var ticking = false;
      var sync = function () {
        ticking = false;
        var reached = trigger.getBoundingClientRect().top < window.innerHeight;
        var onScreen = false;
        for (var k = 0; k < ctas.length; k++) {
          var r = ctas[k].getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) { onScreen = true; break; }
        }
        bar.classList.toggle('el-lr__stickybar--hidden', !reached || onScreen);
      };
      var onScroll = function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(sync); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    }

    /* Countdown to a real deadline. No evergreen mode: if the deadline has passed or
       is unparseable the timer stays hidden and the promo text renders alone. */
    var promo = root.querySelector('[data-lr-promo]');
    var clock = root.querySelector('[data-lr-clock]');
    if (promo && clock && promo.getAttribute('data-deadline')) {
      var end = Date.parse(promo.getAttribute('data-deadline'));
      if (!isNaN(end)) {
        var h = clock.querySelector('[data-h]');
        var m = clock.querySelector('[data-m]');
        var s = clock.querySelector('[data-s]');
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var timer = null;
        var tick = function () {
          var left = end - Date.now();
          if (left <= 0) { clock.hidden = true; if (timer) clearInterval(timer); return; }
          var total = Math.floor(left / 1000);
          h.textContent = pad(Math.floor(total / 3600));
          m.textContent = pad(Math.floor((total % 3600) / 60));
          s.textContent = pad(total % 60);
          clock.hidden = false;
        };
        tick();
        if (!clock.hidden) timer = setInterval(tick, 1000);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
